import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Scrollbars} from 'react-custom-scrollbars';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {structure} from '../../store/actions/block';
import {
    GenerateRecursiveChildsWithParams,
    fixUrl,
    filterPages
} from '../../helpers/Helpers';

import {classNamesPrefixed} from '../../../helpers/CoreHelpers';

import _ from 'lodash';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";

class BlockField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            search: false,
            ids: [],
            blocks: [],
            data: {},
            open: {}
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                blocks: [value],
                ids: [value]
            });
        }
    }

    showModal() {
        this.setState({
            modal: true,
            search: false
        });
    }

    hideModal() {
        this.setState({
            modal: false,
            search: false
        });
    }

    save() {
        this.props.input.onChange(this.state.ids[0]);

        this.setState({
            modal: false,
            search: false
        });
    }

    edit(e) {
        e.preventDefault();

        const {input, block, content} = this.props;

        let ids = [];
        let blocks = [];

        if (input && input.value && block && block.items) {
            const item = _.find(block.items, {id: input.value});

            if (item) {
                ids.push(input.value);

                blocks.push({
                    contentId: input.value,
                    Title: item.title
                });
            }
        }

        this.setState({
            data: {},
            open: {}
        });

        if (content && content.parentWorkspaceId) {
            this.loadStructure(content.parentWorkspaceId);
        }

        this.setState({
            modal: true,
            blocks: blocks,
            ids: ids
        });
    }

    clear(e) {
        e.preventDefault();

        const {input} = this.props;

        input.onChange(null);

        this.setState({
            blocks: [],
            ids: [],
            data: {},
            open: {},
            search: false
        });
    }

    toggleOpen(parentWorkspaceId) {
        const open = this.state.open[parentWorkspaceId];

        this.setState({
            open: {
                ...open,
                [parentWorkspaceId]: !open
            }
        });
    }

    search(e) {
        e.preventDefault();

        const {block} = this.props;

        if (e.target.value && e.target.value !== '') {
            this.setState({
                search: e.target.value
            }, () => {
                this.props.structure(block.parentWorkspaceId, true).then(response => {
                    if (response.data) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                [block.parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, this.state.search, this.props.blockType), block.parentWorkspaceId, this.select.bind(this), this.state.blocks, this.state.search)
                            },
                            open: {
                                ...this.state.open,
                                [block.parentWorkspaceId]: true
                            }
                        }, () => {
                            let target = document.getElementsByClassName('csod-awave--match');

                            if (target && target[0]) {
                                this.scrollbars.scrollTop(target[0].offsetTop);
                            }
                        });
                    }
                });
            });
        } else {
            this.setState({
                search: false
            }, () => {
                this.props.structure(block.parentWorkspaceId, true).then(response => {
                    if (response.data) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                [block.parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, this.state.search, this.props.blockType), block.parentWorkspaceId, this.select.bind(this), this.state.blocks, this.state.search)
                            },
                            open: {
                                ...this.state.open,
                                [block.parentWorkspaceId]: true
                            }
                        }, () => {
                            let target = document.getElementsByClassName('csod-awave--match');

                            if (target && target[0]) {
                                this.scrollbars.scrollTop(target[0].offsetTop);
                            }
                        });
                    }
                });
            });
        }
    }

    select(parentWorkspaceId, id, title) {
        let blockIds = [];
        let ids = [];

        blockIds.push({
            contentId: id,
            Title: title
        });

        ids.push(id);

        this.setState({
            blocks: blockIds,
            ids: ids
        });

        this.props.structure(parentWorkspaceId, true).then(response => {
            if (response.data) {
                this.setState({
                    data: {
                        ...this.state.data,
                        [parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, '', this.props.blockType), parentWorkspaceId, this.select.bind(this), this.state.blocks)
                    },
                    search: false
                });
            }
        });
    }

    loadStructure(parentWorkspaceId) {
        this.props.structure(parentWorkspaceId, true).then(response => {
            if (response.data) {
                this.setState({
                    data: {
                        ...this.state.data,
                        [parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, '', this.props.blockType), parentWorkspaceId, this.select.bind(this), this.state.blocks)
                    }
                });

                this.toggleOpen(parentWorkspaceId);
            }
        });
    }

    isOpen(parentWorkspaceId) {
        return this.state.open[parentWorkspaceId];
    }

    renderPages(parentWorkspaceId) {
        return this.state.data[parentWorkspaceId] ? this.state.data[parentWorkspaceId] : null;
    }

    relatedContent(id) {
        const content = _.find(this.props.content.items, {id: id});
        const block = _.find(this.props.block.items, {id: id});

        if (content) {
            return content;
        } else if (block) {
            return block;
        } else {
            return id;
        }
    }

    render() {
        const {modal, ids} = this.state;
        const {input, label, meta: {touched, error}, workspace, routeParams} = this.props;

        return (
            <div>
                {label &&
                <label>{label}</label>
                }
                <Modal
                    showModal={modal}
                    onClose={() => {
                        this.hideModal();
                    }}
                    title="Add block"
                    icon="th"
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary
                                small
                                title="Save"
                                icon={"save"}
                                onClick={(e) => {
                                    e.preventDefault();

                                    this.save();
                                }}>Save</BtnPrimary>
                        </div>
                    }
                >
                    <div>
                        <div>
                            <div
                                className={classNamesPrefixed({
                                    'form-item': true,
                                    'form-text': true
                                })}
                            >
                                <label htmlFor="search">Search by title</label>
                                <input
                                    type="text"
                                    id="search"
                                    name="search"
                                    placeholder="Search by title"
                                    value={this.state.search ? this.state.search : ''}
                                    onChange={(e) => {
                                        this.search(e);
                                    }}
                                />
                            </div>
                        </div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <label htmlFor="link_url">Block</label>
                            <div className={classNamesPrefixed({'list-selector': true})}>
                                <Scrollbars
                                    ref={(ref) => this.scrollbars = ref}
                                    autoHide={true}
                                    autoHeight={true}
                                    autoHeightMin={0}
                                    autoHeightMax={300}
                                >
                                    <ul>
                                        {workspace.items.map((item) => {
                                            return (
                                                <li
                                                    key={item.id}
                                                    className={classNamesPrefixed({
                                                        'open': this.isOpen(item.id),
                                                        'closed': !this.isOpen(item.id)
                                                    })}
                                                >
                                                    <div
                                                        className={classNamesPrefixed({
                                                            'title': true
                                                        })}
                                                    >
                                                        {item.title}
                                                        <div
                                                            className={classNamesPrefixed({
                                                                'icon': true
                                                            })}
                                                            onClick={(e) => {
                                                                e.preventDefault();

                                                                this.loadStructure(item.id);
                                                            }}
                                                        >
                                                            {this.isOpen(item.id) ? (
                                                                <Icon name="chevron-up"/>
                                                            ) : (
                                                                <Icon name="chevron-down"/>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <ul>
                                                        {this.renderPages(item.id)}
                                                    </ul>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </Scrollbars>
                            </div>
                        </div>
                    </div>
                </Modal>
                <p>
                    <i className={classNamesPrefixed({'grey-color': true})}>Create a block area.</i>
                </p>
                {input.value === '' ? (
                    <div className={classNamesPrefixed({'form-actions': true})}>
                        <BtnSecondary
                            onClick={(e) => {
                                e.preventDefault();

                                this.showModal();
                            }}
                        >
                            Block area
                        </BtnSecondary>
                    </div>
                ) : (
                    <div>
                        <ul className={classNamesPrefixed({'grey-color': true})}>
                            {ids.map((item, index) => {
                                const content = this.relatedContent(item);

                                return (
                                    <li key={index}>
                                        <Icon name="th"/>&nbsp;{content.title}&nbsp;-&nbsp;
                                        <a
                                            href={fixUrl('#/workspace/' + routeParams.workspace + '/block/' + item)}
                                            target="_blank"
                                        >
                                            edit
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary onClick={this.edit.bind(this)}>Edit</BtnPrimary>
                            <BtnSecondary onClick={this.clear.bind(this)}>Remove</BtnSecondary>
                        </div>
                    </div>
                )}
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        workspace: state.workspace,
        block: state.block,
        content: state.content
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        structure: (parentWorkspaceId, skipStore) => dispatch(structure(parentWorkspaceId, skipStore))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockField)



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/BlockField.js